import {
  postJson,
  putJsonForBatch,
  requestDeleteBatchWithBody,
} from '../../../../data/fetchers'
import { Constants } from '../../../../utils/constants'
import { SupplierIdentifierList, SupplierItemList } from './model'

export async function requestUploadSupplierList(
  suppliers: SupplierItemList,
): Promise<any> {
  const result = await putJsonForBatch(
    `/selfservices/suppliers/$batch`,
    suppliers,
  )

  return result
}

export async function requestDeleteSuppliers(
  suppliers: SupplierIdentifierList,
): Promise<any> {
  const result = await requestDeleteBatchWithBody(
    `/selfservices/suppliers/$batch`,
    suppliers,
  )

  return result
}

export async function requestPrepareCsvFile(
  csv: File,
): Promise<SupplierItemList> {
  const formData = new FormData()
  formData.append('file', csv)

  const maxSuppliers = Constants.MaxSuppliers

  const result = await postJson(
    `/selfservices/suppliers/batch/$preparecsv?maxSuppliers=${maxSuppliers}`,
    formData,
  )

  return result as SupplierItemList
}
